import { Loader } from 'components'
import DelayedDetailsRow from 'components/Completeness/DelayedDetailsRow'
import { moment } from 'locale'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { ACTIVE_CLOSED_TAB, DELAYED_STORES_TAB, ZERO_REPORTING_TAB } from './constants'

function DelayedDetails({ delayedECom, delayedNECom, isFetching, storesECom, storesNECom, todayDateChosen, variant }) {
  const { t: translate } = useTranslation()

  if (isFetching) {
    return <Loader />
  }

  const isAfter18 = moment().isAfter(moment('18:00:00', 'hh:mm:ss'))
  let content = (
    <div className="completeness-details-no-delayed-label">
      {variant === DELAYED_STORES_TAB && translate(`revenue.stats.completeness.noDelayedStores${isAfter18 ? 'After16' : ''}`)}
      {variant === ZERO_REPORTING_TAB && translate(`revenue.stats.completeness.noZeroReporting${isAfter18 ? 'After16' : ''}`)}
      {variant === ACTIVE_CLOSED_TAB && translate(`revenue.stats.completeness.noActiveClosed${isAfter18 ? 'After16' : ''}`)}
    </div>
  )

  if (delayedECom > 0 || delayedNECom > 0) {
    content = (
      <>
        <DelayedDetailsRow
          delayed={delayedNECom}
          delayedTotal={storesNECom}
          iconName="shop"
          text={translate('revenue.stats.completeness.storesNECom')}
        />
        <DelayedDetailsRow
          delayed={delayedECom}
          delayedTotal={storesECom}
          iconName="at"
          text={translate('revenue.stats.completeness.storesECom')}
        />
        <div className="completeness-details-delayed-label">
          <span className="completeness-details-delayed-label-value">
            {todayDateChosen &&
              variant === DELAYED_STORES_TAB &&
              translate(`revenue.stats.completeness.storesWithoutReports${isAfter18 ? 'After16' : ''}`)}
            {!todayDateChosen &&
              variant === DELAYED_STORES_TAB &&
              translate('revenue.stats.completeness.storesWithoutReportsPerDay')}
            {todayDateChosen &&
              variant === ZERO_REPORTING_TAB &&
              translate(`revenue.stats.completeness.storesReportingZero${isAfter18 ? 'After16' : ''}`)}
            {!todayDateChosen &&
              variant === ZERO_REPORTING_TAB &&
              translate('revenue.stats.completeness.storesReportingZeroPerDay')}
          </span>
        </div>
      </>
    )
  }

  return <div className="completeness-details-delayed">{content}</div>
}

DelayedDetails.propTypes = {
  delayedECom: PropTypes.number,
  delayedNECom: PropTypes.number,
  isFetching: PropTypes.bool,
  storesECom: PropTypes.number,
  storesNECom: PropTypes.number,
  todayDateChosen: PropTypes.bool,
  variant: PropTypes.string,
}

export default DelayedDetails
